import { createSelector } from '@reduxjs/toolkit';
import { selectRegionalDistrictsModal } from './selectRegionalDistrictsModal';

export const selectRegionalDistrictsForMap = createSelector(selectRegionalDistrictsModal, ({ districts }) => ({
  type: 'FeatureCollection' as const,
  features: districts.map(({ id, coordinates }) => {
    return {
      type: 'Feature' as const,
      id: id.toString(),
      options: { fillColor: '#0468ff1a', strokeColor: '#0468FF' },
      geometry: {
        type: 'Polygon' as const,
        coordinates: coordinates as [number, number][][],
        fillRule: 'evenOdd',
      },
    };
  }),
}));
